export const HetrogenousJobsHiddenFields = new Set(["total_print_cost_per_part", "post_processing_cost_per_part", "total_cost_per_part"])